"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_extras__and__services(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "extras-and-services-hi"), /*#__PURE__*/React.createElement("g", {
    id: "b0d61e54-b2e3-4b3a-8fb3-49b2cc92f861",
    "data-name": "extras-and-services-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "732e59df-09e1-4c50-9122-6865bf143ac5",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6899bdb7-6009-4c29-9aa0-5eb563c7e61c",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fa5da9ad-d0d3-4b22-adf8-e4b7545e5537",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "46ee9b20-f1f9-4b08-9a41-af7f7a740bc9",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c64129d9-b5eb-42ac-9952-332bd0e3e926",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "397891d2-105a-4d5c-817a-3c829b61a9fe",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c3a569ce-36ea-4b16-8a8f-06368947652d",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cc58fcb5-c100-40dc-83f3-de73deb71e86",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a3f90be2-bd48-4783-b267-4fffb524fa8b",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6992548b-5781-40f5-b448-e0a030dd77a0",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f4de089c-3d8f-4960-a361-2f8e3fd1320b",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "daccee96-9b86-43d4-b13f-c9480f3f0083",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "830d7f44-0746-4d4b-8ed8-02a65f74fd6d",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "64b2ca51-27b2-49dd-9761-0ed5e7423c7c",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4ed4b58e-41cd-40e7-a0e6-cb13c4b31691",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5f954c2-8b79-4959-8598-f0453b32d7d8",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b87426d0-3b51-4eac-bac3-79fbdbf444e7",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "073d2751-a68e-4405-bb04-017a4ecfe4b5",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a7583bc2-a12f-4015-873d-1ddb9a11575b",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bee906fb-1b17-4ac3-972e-bd4e9e9cbc49",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7ffb8d64-8031-45d1-91b1-c154b5235357",
    "data-name": "Line_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "179c67b3-fb07-46d6-9b7a-44b2ff972b21",
    "data-name": "Blog_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05581098-a4c3-46f2-9c3c-d8d586668489",
    "data-name": "SoHo_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "48343849-8c5f-410c-a27a-82a928659e70",
    "data-name": "SME_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9d840c33-ac3e-4d0a-8e91-a2584cb597a4",
    "data-name": "Public_sector_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a2771aa7-6a67-49a2-a7f2-142820ea8aea",
    "data-name": "Extras_services_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 160,
    height: 160,
    rx: 80,
    ry: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174h0A80.23,80.23,0,0,1,16,95c0,.33,0,.66,0,1h0a80.24,80.24,0,0,0,80,80h0a80.24,80.24,0,0,0,80-80h0c0-.34,0-.67,0-1A80.23,80.23,0,0,1,96,174Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,144a4,4,0,0,1-4-4V52a4,4,0,0,1,8,0v88A4,4,0,0,1,96,144Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,100H52a4,4,0,0,1,0-8h88a4,4,0,0,1,0,8Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })))))))))))))))))))))))))))));
}

var _default = ic_extras__and__services;
exports.default = _default;